<main id="main-content " tabindex="0">
    <router-outlet></router-outlet>
</main>

